import { LOGO } from '../../core/brand.js';
import { S, UI } from '../../core/store.js';
import { $, mmss } from '../../core/util.js';

export const COLS={
 hero:{n:'Hero film',d:'The main film, delivered in full.'},
 cut:{n:'Cut downs',d:'Shorter edits taken from the hero film.'},
 social:{n:'Social content',d:'Vertical and square edits made for social.'},
 teaser:{n:'Teasers',d:'Short teasers for launch.'},
 bts:{n:'Behind the scenes',d:'Footage and stories from the day.'},
 photo:{n:'Photography',d:'Selects from the shoot, edited and ready to use.'}};

export const FMT={'16:9':[16,9],'9:16':[9,16],'1:1':[1,1],'4:5':[4,5],'3:2':[3,2],'2:3':[2,3]};

export const assetChip=s=>`<span class="chip ${s==='Approved'?'ok':s==='Changes requested'?'bad':'acc'}">${s}</span>`;

export const curAsset=()=>S.assets.find(x=>x.id===UI.aid);

export const pAssets=p=>S.assets.filter(a=>a.pid===p.id);

export const visAssets=p=>pAssets(p).filter(a=>!UI.cv||a.shared);

export const sibs=a=>S.assets.filter(x=>x.pid===a.pid&&x.col===a.col&&(!UI.cv||x.shared));

export const openC=a=>a.comments.filter(c=>!c.res&&(!UI.cv||!c.internal)).length;

export function reviewStats(list){return {n:list.length,ok:list.filter(a=>a.status==='Approved').length,rev:list.filter(a=>a.status==='In review').length,chg:list.filter(a=>a.status==='Changes requested').length,cm:list.reduce((n,a)=>n+openC(a),0)}}

export function frameHtml(a){const r=FMT[a.fmt]||[16,9];return `<div class="frame" style="aspect-ratio:${r[0]}/${r[1]}">${a.img?`<img src="${a.img}" alt="">`:`<img class="wm" src="${LOGO.rw}" alt="">`}</div>`}

export function updPlayer(){
  const a=S.assets.find(x=>x.id===UI.aid);if(!a)return;const dur=a.kind==='video'?a.dur:60;
  const f=$('#tlfill'),h=$('#tlhead'),t=$('#tltime'),c=$('#cat');
  if(f)f.style.width=UI.pl.t/dur*100+'%';if(h)h.style.left=UI.pl.t/dur*100+'%';if(t)t.textContent=mmss(UI.pl.t)+' / '+mmss(dur);if(c)c.textContent=mmss(UI.pl.t);
}
